import {
  typeCurveLifecycleStatus,
  type TypeCurveLifecycleFields,
} from './lifecycle-status';
import { LifecycleStatusTag } from './lifecycle-status-tag';

/**
 * The lifecycle tag for a Type Curve version (Promoted, Draft, Archived or Default), or nothing
 * when the status is unknown. See typeCurveLifecycleStatus for the precedence.
 *
 * @param {TypeCurveLifecycleFields & {className?: string}} props - The version's fields.
 * @return {JSX.Element | null} The tag.
 */
export function TypeCurveStatusTag({
  className,
  ...fields
}: TypeCurveLifecycleFields & { className?: string }) {
  const status = typeCurveLifecycleStatus(fields);
  return status ? (
    <LifecycleStatusTag
      status={status}
      subject="type-curve"
      className={className}
    />
  ) : null;
}
